import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { BillingInformationContext } from "../../Account/BillingInformation/BillingInformationContext";
import { useCompanyConfigQuery } from "../../SWR/Company/useCompanyConfigQuery";
import { useCurrencyLocalizer } from "../../Shared/hooks/useCurrencyLocalizer";
import { CheckoutContext } from "../CheckoutContext";
import { usePaymentMethods } from "../../SWR/Payments/usePaymentMethods";
export const useGiftCardCheckout = () => {
    const location = useLocation();
    // Get payment data from SWR
    const { primaryCreditCard, revalidatePaymentMethods } = usePaymentMethods();
    // Get UI state from context
    const { resetContext: resetBillingInfoContext, token, authorizeUrl, paymentIntentId, paymentProcessor, } = useContext(BillingInformationContext);
    const { resetContext: resetCheckoutContext } = useContext(CheckoutContext);
    const { mobileRedirectFailureUrl, mobileRedirectSuccessUrl, openedFromMobileApp } = useCompanyConfigQuery();
    const giftCardState = location.state.giftCardState;
    const { localizedCurrencyText: giftCardCurrencyText } = useCurrencyLocalizer(giftCardState.amount);
    return {
        total: giftCardState.amount,
        giftCardCurrencyText,
        giftCardState,
        primaryCreditCard,
        token,
        authorizeUrl,
        paymentIntentId,
        paymentProcessor,
        mobileRedirectFailureUrl,
        mobileRedirectSuccessUrl,
        openedFromMobileApp,
        resetBillingInfoContext,
        resetCheckoutContext,
        revalidatePaymentMethods,
    };
};
